module.exports = __webpack_public_path__ + "img/secher.9f094978.png";